export default {
  relatedContent: [
    {
      link: '/what-is-a-quantum-dataset',
      label: 'What is Quantum Data?',
      image: 'https://assets.cloud.pennylane.ai/datasets/related_content/data_module.png',
    },
    {
      link: 'https://docs.pennylane.ai/en/stable/introduction/data.html',
      label: 'Quantum Datasets Introduction',
      image:
        'https://assets.cloud.pennylane.ai/pennylane_website/pages/landing_page/getting_started_section/documentation.png',
    },
    {
      link: 'https://pennylane.ai/qml/demos/tutorial_classical_shadows',
      label: 'Classical Shadows',
      image: 'https://assets.cloud.pennylane.ai/datasets/related_content/atom_shadow.png',
    },
  ],
}
